/* tslint:disable */
/* eslint-disable */
/**
 * Ameta hms API
 * A rest api for managing the ameta hms system
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    NhYearDataObject,
    NhYearDataObjectFromJSON,
    NhYearDataObjectFromJSONTyped,
    NhYearDataObjectToJSON,
} from './';

/**
 * 
 * @export
 * @interface HMSCounterDataNh
 */
export interface HMSCounterDataNh {
    /**
     * 
     * @type {{ [key: string]: NhYearDataObject; }}
     * @memberof HMSCounterDataNh
     */
    years: { [key: string]: NhYearDataObject; };
}

export function HMSCounterDataNhFromJSON(json: any): HMSCounterDataNh {
    return HMSCounterDataNhFromJSONTyped(json, false);
}

export function HMSCounterDataNhFromJSONTyped(json: any, ignoreDiscriminator: boolean): HMSCounterDataNh {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'years': (mapValues(json['years'], NhYearDataObjectFromJSON)),
    };
}

export function HMSCounterDataNhToJSON(value?: HMSCounterDataNh | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'years': (mapValues(value.years, NhYearDataObjectToJSON)),
    };
}


